/** SMS connector display name used to resolve the authenticated workspace connector. */
export const SMS_CONNECTOR_NAME = 'Sms';

/** Connector flow names (must match workspace connector flow configuration for the SMS connector). */
export const SMS_CONNECTOR_FLOW_NAME = 'Send';
export const SMS_TEMPLATE_LIST_FLOW_NAME = 'Template List';
export const SMS_TEMPLATE_INSERT_FLOW_NAME = 'Insert Template';
export const SMS_TEMPLATE_EDIT_FLOW_NAME = 'Edit Template';
export const SMS_TEMPLATE_DELETE_FLOW_NAME = 'Delete Template';
export const SMS_ALIAS_LIST_FLOW_NAME = 'Alias List';
